import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { FormContainer } from '../Form'
import { isEmptyString } from '../../../../../../helpers/sanityChecks'
import { isDateValid, validateFields } from '../../../../../../helpers/collaborativeIndexations'
import { IdentityContainer } from './FormSteps/Identity'
import { MilitaryRecordContainer } from './FormSteps/MilitaryRecord'
import More from './FormSteps/More.jsx'

class FrenchMilitaryRecordForm extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        defaultConscriptionYear: PropTypes.number,
        defaultCountry: PropTypes.string.isRequired,
        defaultDepartment: PropTypes.string.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        defaultMilitaryRecordRegistry: PropTypes.string,
    }

    constructor(props)
    {
        super(props)

        this.formSteps = [
            IdentityContainer,
            More,
            MilitaryRecordContainer,
        ]

        this.formStepsValidation = {
            2: () => {
                validateFields({
                    lastname: () => ! isEmptyString(this.props.fields.lastname),
                    birthDate: () => this.props.fields.birthDate === null || isDateValid(this.props.fields.birthDate),
                })
            },
        }
    }

    componentDidMount()
    {
        const { updateFieldValue, defaultConscriptionYear, defaultMilitaryRecordRegistry, defaultDepartment, defaultCountry } = this.props

        updateFieldValue('conscriptionYear', defaultConscriptionYear)
        updateFieldValue('militaryRecordRegistry', defaultMilitaryRecordRegistry)
        updateFieldValue('documentType', 'militaryRecord')
        updateFieldValue("birthDepartment", defaultDepartment)
        updateFieldValue("birthCountry", defaultCountry)
        updateFieldValue("homeDepartment", defaultDepartment)
        updateFieldValue("homeCountry", defaultCountry)
    }

    render()
    {
        return (
            <FormContainer steps={ this.formSteps } stepsValidation={ this.formStepsValidation } />
        )
    }
}

export default withTranslation()(FrenchMilitaryRecordForm)
